var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ARQuickLook"},[_c('div',[_c('a',{attrs:{"rel":"ar","href":"./static/amoureux.usdz"}},[_c('img',{attrs:{"src":require('./models/amoureux.png')}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }